import { Permission } from '../lib';
import { useCurrentCompany } from './use-current-company';
import { usePermission } from './use-permission';

/**
 * Role-aware hook for Bizy visibility.
 *
 * Admins see Bizy when `bizy_for_admins` is enabled; employees see it when
 * `bizy_for_employees` is enabled. The backend resolution already cascades
 * the parent `bizy` state into each child, so checking children is sufficient.
 *
 * Falls back to `bizy_enabled` when `feature_states` is not yet available.
 */
export function useIsBizyEnabled(): boolean {
	const company = useCurrentCompany();
	const isAdmin = usePermission(Permission.CanViewAdmin);

	const states = company?.feature_states;
	const key = isAdmin ? 'bizy_for_admins' : 'bizy_for_employees';

	if (states && key in states) {
		return states[key] ?? false;
	}

	return company?.bizy_enabled || false;
}
